import React, { useEffect, useState } from 'react';
import { getProductDetail, getProductInfo  } from '../controllers/ProductsConnectionLayer';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { useCart } from '../contexts/CartContext';
import "../style/ProductPage.css";
import "../style/AppPages.css"
import Loading from '../components/Loading';
import { fetchUserDataFromBd } from "../controllers/AccountConnectionLayer";
import { useAuth } from '../contexts/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { Trans, useTranslation } from 'react-i18next';
import { useCurrency } from '../contexts/CurrencyContext';
import { homeImages, siliconePourGifUrl } from '../images/siteImages';
import { getSelectedLanguageOption } from '../i18n';

const ProductPage = () => {
  const { t, i18n } = useTranslation();
  const currentLang = getSelectedLanguageOption(i18n.language).value;

  const { addToCart } = useCart();
  const { user } = useAuth(); // Get user state
  const { selectedCurrency, currencySymbol, formatPrice } = useCurrency();


  const navigate = useNavigate();
  const location = useLocation();
  const { name } = useParams();
  
  const [hoveredLeft, setHoveredLeft] = useState(false);
  const [hoveredRight, setHoveredRight] = useState(false);
  
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedDimensions, setSelectedDimensions] = useState(null);
  const [selectedWeight, setSelectedWeight] = useState(null);
  const [selectedFirmness, setSelectedFirmness] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);

  const [useImperial, setUseImperial] = useState(true);
  const [isSizingOpen, setIsSizingOpen] = useState(false);
  
 const [currentCustomPrice, setCurrentCustomPrice] = useState(null);
 const [currentCustomPriceCad, setCurrentCustomPriceCad] = useState(null);

  const [productInfo, setProductInfo] = useState([]);
  const [productDetail, setProductDetail] = useState([]);
  const [productImageUrls, setProductImageUrls] = useState([]);
  const [loading, setLoading] = useState(true);

  const [activeTab, setActiveTab] = useState("size");
  const [hasFantasy, setHasFantasy] = useState(false);

  const [numberOfItems, setNumberOfItems] = useState(1);

  const [selectedSlide, setSelectedSlide] = useState(0);

  const discreetExpeditionImageUrl = homeImages[currentLang.toUpperCase()].discreetExpedition;
  const siliconeQualityImageUrl = homeImages[currentLang.toUpperCase()].siliconeQualityVisual;

  const [imagesLoaded, setImagesLoaded] = useState(0);

  const handleImageLoad = () => {
    setImagesLoaded(prev => prev + 1);
  };

  const moreItems = () => {
    setNumberOfItems(numberOfItems + 1);
  }

  const lessItems = () => {
    if (numberOfItems > 1) {
      setNumberOfItems(numberOfItems - 1);
    }
  }

  const handleAddToCart = () => {
    const priceBreakdown = [
      Number(selectedSize?.priceCAD ?? 0),
      Number(selectedFirmness?.priceCAD ?? 0),
      Number(selectedOption?.priceCAD ?? 0),
      Number(selectedColor?.priceCAD ?? 0),
    ];

    const product = {
      id: Math.random(),
      productId: productInfo.id,
      name: productInfo.name,
      nameFR: productInfo.nameFR,
      price: currentCustomPriceCad,
      prcbdn: priceBreakdown,
      selectedSize: selectedSize, 
      selectedFirmness: selectedFirmness,
      selectedOption: selectedOption,
      selectedColor: selectedColor,
      previewUrl: productInfo.previewUrl,
      weight: selectedWeight,
      dimensions: selectedDimensions,
      numberOfItems: numberOfItems,
      isCustom: productDetail.isCustom,
      type: productInfo.typeId,
      hsCode: productInfo.hsCode,
      oc: productInfo.oc,
      ed: productInfo.ed
    };
    addToCart(product);
  };

  const circumference = (diameter) => {
    return Math.PI * diameter;
  }
  
  const hasMeasurement = (key) => {
    return productDetail.dimensions?.some(drone => drone[key] !== undefined && drone[key] !== null);
  };
  

  const arrowStyleRight = {
    position: 'absolute',
    zIndex: 2,
    top: 'calc(50% - 15px)',
    width: 20,
    height: 20,
    cursor: 'pointer',
    color: hoveredRight ? 'lightgray' : 'gray',
    right: 15,
    transition: 'color 0.3s ease',
    border: 'none',
    background: 'none',
    outline: 'none',
    fontSize: '20px',
  };

  const arrowStyleLeft = {
    position: 'absolute',
    zIndex: 2,
    top: 'calc(50% - 15px)',
    width: 20,
    height: 20,
    cursor: 'pointer',
    color: hoveredLeft ? 'lightgray' : 'gray',
    left: 15,
    transition: 'color 0.3s ease',
    border: 'none',
    background: 'none',
    outline: 'none',
    fontSize: '20px',
  };

  const renderArrowPrev = (onClickHandler, hasPrev, label) =>
    hasPrev && (
      <button onClick={onClickHandler} title={label} style={{ ...arrowStyleLeft }} onMouseEnter={() => setHoveredLeft(true)} // Hover start
      onMouseLeave={() => setHoveredLeft(false)}>&#9664;</button>
    );

  const renderArrowNext = (onClickHandler, hasNext, label) =>
    hasNext && (
      <button onClick={onClickHandler} title={label} style={{ ...arrowStyleRight  }} onMouseEnter={() => setHoveredRight(true)} // Hover start
      onMouseLeave={() => setHoveredRight(false)}>&#9654;</button>
    );

    const handleSizeSelection = (size, index) => {
      setSelectedSize(size);
      const slideBuffer = productImageUrls.length - productDetail.availableSizes.length;
      setSelectedSlide(slideBuffer + index);

      const weightIndex = productDetail.availableSizes.findIndex(
        (availableSize) => availableSize === size
      );

      if (weightIndex !== -1) {
        const matchingWeight = productDetail.weight[weightIndex];
        setSelectedWeight(matchingWeight);
      }

      setSelectedDimensions(productDetail.dimensions[index]);
    };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const productInfo = await getProductInfo(name);
        const productDetail = await getProductDetail(productInfo.id, name);

        if (productDetail.availableSizes && productDetail.availableSizes.length == 1) {
          
          setSelectedSize(productDetail.availableSizes[0]);
          
          if (productDetail.weight){
            setSelectedWeight(productDetail.weight[0]);
          }

          if (productDetail.dimensions){
            setSelectedDimensions(productDetail.dimensions[0]);
          }

          // If only one custom size, skip size tab and go directly to color
          if (productDetail.isCustom) {
            setActiveTab("color");
          } else {
            setActiveTab("size");
          }
        } else {
          // Multiple sizes, start with size tab
          setActiveTab("size");
        }
        
        setProductInfo(productInfo);
        setProductDetail(productDetail);
        setProductImageUrls(productDetail.imageUrls);
      } catch (error) {
        console.error("Error fetching data: ", error);
      } finally {
        setLoading(false);
      }
    };
    

    fetchData();
  }, [name]);

  useEffect(() => {
    if (selectedSize != null || selectedFirmness != null || selectedOption != null || selectedColor != null) {
      const cadPrice =
        (+selectedSize?.priceCAD || 0) +
        (+selectedFirmness?.priceCAD || 0) +
        (+selectedOption?.priceCAD || 0) +
        (+selectedColor?.priceCAD || 0);

      const convertedPrice =
        (+selectedSize?.price || 0) +
        (+selectedFirmness?.price || 0) +
        (+selectedOption?.price || 0) +
        (+selectedColor?.price || 0);
 
      setCurrentCustomPriceCad(cadPrice);
      setCurrentCustomPrice(formatPrice(convertedPrice));
    }
  }, [selectedSize, selectedFirmness, selectedOption, selectedColor, formatPrice]);

  const handleTabClick = (newTab) => {
    setActiveTab(newTab);
  };

  useEffect(() => {
    async function fetchUserData() {
        if (user) {
            const data = await fetchUserDataFromBd(user.id);
            setHasFantasy(data.fantasy);
        }
    }
    fetchUserData();
  }, [user]);

  return (
    <>
    <Loading isVisible={loading} />
      {!loading && (
        <div class="page-padding product-page-padding">
          <div class="product-page-upper">
            <div class="row">
              <div class="images-carrousel">
                <Carousel selectedItem={selectedSlide} useKeyboardArrows={true} swipeable={true} showStatus={false} renderArrowPrev={renderArrowPrev}
                renderArrowNext={renderArrowNext}>
                  {productImageUrls.map(productImageUrl => {
                    return(
                      <div key={productImageUrls}>
                        <img src={productImageUrl} />
                      </div>
                    )
                  })}
                </Carousel>

                <div className="lower-text lower-desc">
                  <p>
                    {(i18n.language === 'fr' && productInfo.descriptionFR ? productInfo.descriptionFR : productInfo.description)?.replace(/\\n/g, "\n").split("\n").map((line, index) => (
                      <React.Fragment key={index}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </p>

                  {productInfo.story && !hasFantasy && (
                  <p className="small-info-text">
                    <Trans i18nKey="product.exploreFantasy" values={{ name: i18n.language === 'fr' && productInfo.nameFR ? productInfo.nameFR : productInfo.name }} components={{ 1: <strong />, 2: <a href="/account/update" className="no-link-color" /> }} />
                  </p>
                )}
                </div>
              </div>
              <div class="information-section">
                <div class="prod-title-line">
                  <span className='prod-name'>{i18n.language === 'fr' && productInfo.nameFR ? productInfo.nameFR : productInfo.name}</span>
                </div>



                <div className="creation-section">
                  {productDetail.availableSizes && productDetail.isCustom && (
                  <div className="tabs-container">
                    {productDetail.availableSizes.length > 1 && (
                      <button 
                          className={`tab-button tab-button-wide ${activeTab === "size" ? "active" : ""}`} 
                          onClick={() => handleTabClick("size")}
                      >
                          <span>{t("checkout.sizeLabel")}</span>
                      </button>
                    )}
                    {productDetail.isCustom && (
                      <button 
                          className={`tab-button tab-button-wide ${activeTab === "color" ? "active" : ""}`} 
                          onClick={() => handleTabClick("color")}
                          disabled={selectedSize === null}
                      >
                          <span>{t("checkout.colorLabel")}</span>
                      </button>
                    )}

                    {productDetail.availableFirmness && productDetail.availableFirmness.length > 0 && (
                    <button 
                        className={`tab-button tab-button-wide ${activeTab === "firmness" ? "active" : ""}`} 
                        onClick={() => handleTabClick("firmness")}
                        disabled={selectedColor === null}
                    >
                        <span>{t("checkout.softnessLabel")}</span>
                    </button>
                    )}
                    
                    {productDetail.availableOptions && productDetail.availableOptions.length > 0 && (
                      <button 
                          className={`tab-button tab-button-wide ${activeTab === "options" ? "active" : ""}`} 
                          onClick={() => handleTabClick("options")}
                          disabled={selectedFirmness === null}
                      >
                          <span>{t("checkout.optionsLabel")}</span>
                      </button>
                    )}
                  </div>
                  )}

                {productDetail.availableSizes && productDetail.isCustom ? (
                  <div className={`customization-section normal-section ${selectedColor && activeTab === "color" ? 'expanded' : ''}`}>
                    {activeTab === "size" && productDetail.availableSizes.length > 1 && (
                      <div className="customization-content">
                        <h3>{t("product.sizesLabel")}</h3>
                        <div className="boutons-size">
                        {productDetail.availableSizes?.map((size, index) => {
                          const minPrice = Math.min(...productDetail.availableSizes.map(s => s.price)); // Get lowest price
                          const priceDifference = formatPrice(size.price - minPrice); // Calculate difference
                          
                          return (
                            <button
                              key={size}
                              className={`button-option autre-options button-option-text ${selectedSize === size ? "selected" : ""}`}
                              onClick={() => handleSizeSelection(size, index)}
                            >
                              <p>{t("options.size" + size.description)}</p>
                              <p>{priceDifference > 0 ? `(+${priceDifference})` : ''}</p>
                            </button>
                          );
                        })}
                        </div>

                        <div className="buttom-set-in-place">
                          {productDetail.isCustom ? (
                            <button className="form-button next-button" onClick={() => handleTabClick("color")} disabled={selectedSize == null}>
                              {t("product.nextButton")}
                            </button>
                          ) : (
                            <button class="form-button add-button" onClick={handleAddToCart} disabled={selectedSize == null}>Add to cart</button>
                          )}
                          
                          <div className="price-container-price">
                            <span className={`prod-price-label ${selectedSize ? "slide-out" : ""}`}>{t("productCard.startingPriceLabel")}</span>
                            <span className="prod-price">{currencySymbol}{currentCustomPrice ?? formatPrice(productInfo.price)} {selectedCurrency}</span>
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === "color" && (
                      <div className="customization-content">
                      <div class="horitontal-disclamer-and-title">
                        <h3>{t("product.colorsLabel")}</h3>
                        <p class="small-disclamer"><strong>*</strong> {t("product.exempleOnly")}</p>
                      </div>
                      <div className="boutons-size">
                        {productDetail.availableThemedColors.map((option) => (
                          <img 
                          className={`image-couleur ${selectedColor === option ? "selected" : ""}`}
                            src={option.previewUrl} 
                            alt={option.description} 
                            key={option}
                            onClick={() => setSelectedColor(option)}
                          />
                        ))}
                    
                        {productDetail.availableColors.map((option) => (
                          <img 
                            className={`image-couleur ${selectedColor === option ? "selected" : ""}`}
                            src={option.previewUrl} 
                            alt={option.description} 
                            key={option}
                            onClick={() => setSelectedColor(option)}
                            />
                        ))}
                      </div>
                    
                      {/* {selectedColor && (
                        <div className="selected-color-info">
                          
                        </div>
                      )}
                     */}
                      <div class="lower-section-cool-look">
                        <div className={`selected-color-info ${selectedColor ? 'slide-in' : ''}`}>
                          {selectedColor && (
                            <div className="selected-color-beans">
                              <img className='image-couleur' src={selectedColor.previewUrl} alt={selectedColor.description} />
                              <span><strong>{t("product.selectedColorLabel")} : </strong>{selectedColor.description}</span>
                              <span>{selectedColor.price > 0 ? `+${currencySymbol}${formatPrice(selectedColor.price)}` : t("product.includedLabel")}</span>
                            </div>
                          )}
                        </div>

                        <div className={`buttom-set-in-place ${selectedColor ? 'slide-in' : ''}`}>
                          {productDetail.availableFirmness && productDetail.availableFirmness.length > 0 ? (
                          <button className="form-button next-button" onClick={() => handleTabClick("firmness")} disabled={!selectedColor}>
                            {t("product.nextButton")}
                          </button>
                          ) : (
                            <button class="form-button add-button" onClick={handleAddToCart} disabled={selectedColor == null || selectedSize == null}>Add to cart</button>
                          )}
                      
                          <div className="price-container-price">
                            <span className="prod-price">{currencySymbol}{currentCustomPrice ?? formatPrice(productInfo.price)} {selectedCurrency}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    )}

                    {activeTab === "firmness" && (
                      <div className="customization-content">
                        <h3>{t("product.softnessLabel")}</h3>
                        <div class="boutons-softness">
                          {productDetail?.availableFirmness?.map(firmness => {
                            return(
                              <button
                              key={firmness}
                              className={`button-option autre-options button-option-text ${
                                selectedFirmness === firmness ? "selected" : ""
                              }`}
                              onClick={() => setSelectedFirmness(firmness)}
                            >
                              {t("options.firmness" + firmness)}
                            </button>
                            )
                          })}

                          {productDetail.availableCustomFirmness.map((size) => (
                            <button
                              key={size}
                              className={`button-option autre-options button-option-text ${
                                selectedFirmness === size ? "selected" : ""
                              }`}
                              onClick={() => setSelectedFirmness(size)}
                            >
                              <p>{t("options.firmness" + size.description)}</p>
                              <p>{size.price > 0 ? `(+${currencySymbol}${formatPrice(size.price)})` : ''}</p>
                            </button>
                          ))}
                        </div>

                        <div className="buttom-set-in-place">
                          { productDetail.availableOptions && productDetail.availableOptions.length > 0 ? (
                            <button className="form-button next-button" disabled={selectedFirmness == null} onClick={() => handleTabClick("options")}>
                              {t("product.nextButton")}
                            </button>
                            ) : (
                              <button class="form-button add-button" onClick={handleAddToCart} disabled={selectedColor == null || selectedSize == null || selectedFirmness == null}>{t("product.addToCartLabel")}</button>
                            )}
                          
                          <div className="price-container-price">
                            <span className="prod-price">{currencySymbol}{currentCustomPrice ?? formatPrice(productInfo.price)} {selectedCurrency}</span>
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === "options" && (
                      <div className="customization-content">
                        <h3>{t("product.optionsLabel")}</h3>
                        <div className="boutons-size">
                          <button
                              key="default"
                              className={`button-option autre-options button-option-text ${
                                selectedOption === null ? "selected" : ""
                              }`}
                              onClick={() => setSelectedOption(null)}
                              // disabled={selectedSize === null || selectedFirmness===null}
                            >
                              <p>{t("checkout.noneLabel")}</p>
                            </button>
                          {productDetail.availableOptions.map((option) => (
                            <button
                              key={option}
                              className={`button-option autre-options button-option-text ${
                                selectedOption === option ? "selected" : ""
                              }`}
                              onClick={() => setSelectedOption(selectedOption === option ? null : option)}
                              // disabled={selectedSize === null || selectedFirmness===null}
                            >
                              <p>{t("options.option" + option.description)}</p>
                              <p>{option.price > 0 ? `(+${currencySymbol}${formatPrice(option.price)})` : ''}</p>
                            </button>
                          ))}
                        </div>

                        
                        <div className="buttom-set-in-place">
                          <button class="form-button add-button" onClick={handleAddToCart} disabled={selectedColor == null || selectedSize == null || selectedFirmness == null}>{t("product.addToCartLabel")}</button>
                          
                          <div className="price-container-price">
                            <span className="prod-price">{currencySymbol}{currentCustomPrice ?? formatPrice(productInfo.price)} {selectedCurrency}</span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  ) : (
                    <div className={`customization-section small-section ${selectedColor && activeTab === "color" ? 'expanded' : ''}`}>
                      <div className="customization-content horitontal-content">
                        <h3>{t("checkout.quantityLabel")}</h3>
                        <div className="bouton-add">
                          <button id="minus" onClick={lessItems}>−</button>
                          <input type="number" value={numberOfItems} id="input"/>
                          <button id="plus" onClick={moreItems}>+</button>
                        </div>
                      <div className="buttom-set-in-place">
                        <button class="form-button add-button" onClick={handleAddToCart}>{t("product.addToCartLabel")}</button>
                    
                          <div className="price-container-price">
                            <span className="prod-price">{currencySymbol}{currentCustomPrice ?? formatPrice(productInfo.price)} {selectedCurrency}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {productDetail.dimensions && (
                    <div className={`dimensions-section ${isSizingOpen ? "dimensions-section-bottom" : ""}`}>
                      <div className="dimensions-header">
                        <h3 onClick={() => setIsSizingOpen(!isSizingOpen)}>{t("product.sizingInfoLabel")}</h3>
                        <button 
                          className="toggle-button" 
                          onClick={() => setIsSizingOpen(!isSizingOpen)}
                        >
                          {isSizingOpen ? 
                          <FontAwesomeIcon icon={faChevronUp} color="whitesmoke" /> : <FontAwesomeIcon icon={faChevronDown} color="whitesmoke" />}
                        </button>
                      </div>

                      {isSizingOpen && (
                        <>
                          <div className="toggle-button-container">
                            <button className="smaller-button" onClick={() => setUseImperial(true)}>
                              {t("product.imperialLabel")}
                            </button>
                            <button className="smaller-button" onClick={() => setUseImperial(false)}>
                              {t("product.metricLabel")}
                            </button>
                          </div>
                          <table className="drone-table">
                            <thead>
                              <tr>
                                <th>{t("product.mesurementsLabel")}</th>
                                {productDetail.dimensions?.map((drone, index) => (
                                  <th key={index}>{drone.description}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {hasMeasurement('BaseDiameter') && (
                                <tr>
                                  <td>{t("product.baseDia")} {useImperial ? '(in)' : '(cm)'}</td>
                                  {productDetail.dimensions?.map((drone, index) => (
                                    <td key={index}>
                                      {useImperial
                                        ? (drone.BaseDiameter * 0.393701).toFixed(1)
                                        : drone.BaseDiameter.toFixed(1)}
                                    </td>
                                  ))}
                                </tr>
                              )}
                              {hasMeasurement('BaseDiameter') && (
                                <tr>
                                  <td>{t("product.baseCirc")} {useImperial ? '(in)' : '(cm)'}</td>
                                  {productDetail.dimensions?.map((drone, index) => (
                                    <td key={index}>
                                      {useImperial
                                        ? (circumference(drone.BaseDiameter) * 0.393701).toFixed(1)
                                        : circumference(drone.BaseDiameter).toFixed(1)}
                                    </td>
                                  ))}
                                </tr>
                              )}
                              {hasMeasurement('KnotDiameter') && (
                                <tr>
                                  <td>{t("product.knotDia")} {useImperial ? '(in)' : '(cm)'}</td>
                                  {productDetail.dimensions?.map((drone, index) => (
                                    <td key={index}>
                                      {useImperial
                                        ? (drone.KnotDiameter * 0.393701).toFixed(1)
                                        : drone.KnotDiameter.toFixed(1)}
                                    </td>
                                  ))}
                                </tr>
                              )}
                              {hasMeasurement('KnotDiameter') && (
                                <tr>
                                  <td>{t("product.knotCirc")} {useImperial ? '(in)' : '(cm)'}</td>
                                  {productDetail.dimensions?.map((drone, index) => (
                                    <td key={index}>
                                      {useImperial
                                        ? (circumference(drone.KnotDiameter) * 0.393701).toFixed(1)
                                        : circumference(drone.KnotDiameter).toFixed(1)}
                                    </td>
                                  ))}
                                </tr>
                              )}
                              {hasMeasurement('ShaftDiameter') && (
                                <tr>
                                  <td>{t("product.shaftDia")} {useImperial ? '(in)' : '(cm)'}</td>
                                  {productDetail.dimensions?.map((drone, index) => (
                                    <td key={index}>
                                      {useImperial
                                        ? (drone.ShaftDiameter * 0.393701).toFixed(1)
                                        : drone.ShaftDiameter.toFixed(1)}
                                    </td>
                                  ))}
                                </tr>
                              )}
                              {hasMeasurement('ShaftDiameter') && (
                                <tr>
                                  <td>{t("product.shaftCirc")} {useImperial ? '(in)' : '(cm)'}</td>
                                  {productDetail.dimensions?.map((drone, index) => (
                                    <td key={index}>
                                      {useImperial
                                        ? (circumference(drone.ShaftDiameter) * 0.393701).toFixed(1)
                                        : circumference(drone.ShaftDiameter).toFixed(1)}
                                    </td>
                                  ))}
                                </tr>
                              )}
                              {hasMeasurement('HeadDiameter') && (
                                <tr>
                                  <td>{t("product.headDia")} {useImperial ? '(in)' : '(cm)'}</td>
                                  {productDetail.dimensions?.map((drone, index) => (
                                    <td key={index}>
                                      {useImperial
                                        ? (drone.HeadDiameter * 0.393701).toFixed(1)
                                        : drone.HeadDiameter.toFixed(1)}
                                    </td>
                                  ))}
                                </tr>
                              )}
                              {hasMeasurement('HeadDiameter') && (
                                <tr>
                                  <td>{t("product.headCirc")} {useImperial ? '(in)' : '(cm)'}</td>
                                  {productDetail.dimensions?.map((drone, index) => (
                                    <td key={index}>
                                      {useImperial
                                        ? (circumference(drone.HeadDiameter) * 0.393701).toFixed(1)
                                        : circumference(drone.HeadDiameter).toFixed(1)}
                                    </td>
                                  ))}
                                </tr>
                              )}
                              {hasMeasurement('InnerDiameter') && (
                                <tr>
                                  <td>{t("product.innerDia")} {useImperial ? '(in)' : '(cm)'}</td>
                                  {productDetail.dimensions?.map((drone, index) => (
                                    <td key={index}>
                                      {useImperial
                                        ? (drone.InnerDiameter * 0.393701).toFixed(1)
                                        : drone.InnerDiameter.toFixed(1)}
                                    </td>
                                  ))}
                                </tr>
                              )}
                              {hasMeasurement('InnerDiameter') && (
                                <tr>
                                  <td>{t("product.innerCirc")} {useImperial ? '(in)' : '(cm)'}</td>
                                  {productDetail.dimensions?.map((drone, index) => (
                                    <td key={index}>
                                      {useImperial
                                        ? (circumference(drone.InnerDiameter) * 0.393701).toFixed(1)
                                        : circumference(drone.InnerDiameter).toFixed(1)}
                                    </td>
                                  ))}
                                </tr>
                              )}
                              {hasMeasurement('EntryDiameter') && (
                                <tr>
                                  <td>{t("product.entryDia")} {useImperial ? '(in)' : '(cm)'}</td>
                                  {productDetail.dimensions?.map((drone, index) => (
                                    <td key={index}>
                                      {useImperial
                                        ? (drone.EntryDiameter * 0.393701).toFixed(1)
                                        : drone.EntryDiameter.toFixed(1)}
                                    </td>
                                  ))}
                                </tr>
                              )}
                              {hasMeasurement('EntryDiameter') && (
                                <tr>
                                  <td>{t("product.entryCirc")} {useImperial ? '(in)' : '(cm)'}</td>
                                  {productDetail.dimensions?.map((drone, index) => (
                                    <td key={index}>
                                      {useImperial
                                        ? (circumference(drone.EntryDiameter) * 0.393701).toFixed(1)
                                        : circumference(drone.EntryDiameter).toFixed(1)}
                                    </td>
                                  ))}
                                </tr>
                              )}
                              {hasMeasurement('UsableLength') && (
                                <tr>
                                  <td>{t("product.usableLen")} {useImperial ? '(in)' : '(cm)'}</td>
                                  {productDetail.dimensions?.map((drone, index) => (
                                    <td key={index}>
                                      {useImperial
                                        ? (drone.UsableLength * 0.393701).toFixed(1)
                                        : drone.UsableLength.toFixed(1)}
                                    </td>
                                  ))}
                                </tr>
                              )}
                              {hasMeasurement('TotalLength') && (
                                <tr>
                                  <td>{t("product.totalLen")} {useImperial ? '(in)' : '(cm)'}</td>
                                  {productDetail.dimensions?.map((drone, index) => (
                                    <td key={index}>
                                      {useImperial
                                        ? (drone.TotalLength * 0.393701).toFixed(1)
                                        : drone.TotalLength.toFixed(1)}
                                    </td>
                                  ))}
                                </tr>
                              )}
                            </tbody>
                          </table>

                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {hasFantasy && productInfo.story && (
              <div className="story-section">
                <div class="left-horizontal-container smaller-even">
                    <div class="thick-purple-horizontal"></div>
                </div>
                <h2>{t("product.meetLabel")} {i18n.language === 'fr' && productInfo.nameFR ? productInfo.nameFR : productInfo.name}~</h2>
                <p>
                  {(i18n.language === 'fr' && productInfo.storyFR ? productInfo.storyFR : productInfo.story)?.replace(/\\n/g, "\n").split("\n").map((line, lineIndex) => (
                    <React.Fragment key={lineIndex}>
                      {line.split(/(<i>.*?<\/i>)/g).map((part, partIndex) =>
                        part.startsWith('<i>') && part.endsWith('</i>')
                          ? <em key={partIndex}>{part.slice(3, -4)}</em>
                          : part
                      )}
                      <br />
                    </React.Fragment>
                  ))}
                </p>
              </div>
            )}
          </div>

          <div>
            <div class="image-section image-overlay-stack">
              <img class="max-width-img overlay-base" src={siliconePourGifUrl} alt="Silicone Pour" onLoad={handleImageLoad}/>
              <img class="max-width-img overlay-top" src={siliconeQualityImageUrl} alt="Silicone Quality" onLoad={handleImageLoad} />
            </div>

            <div class="horizontal-container horizontal-container-no-top">
              <div class="horizontal horizontal-square"></div>
            </div>

            <div class="image-section">
              <img class="max-width-img" src={discreetExpeditionImageUrl} alt="Discreet Expedition" onLoad={handleImageLoad} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductPage;